function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { deepMerge } from './utils';
import { Motion, AnimatePresence as MotionAnimatePresence, createMotionAnimatedComponent } from '@legendapp/motion';
import { MotionSvg } from '@legendapp/motion/svg';
// import { propertyTokenMap } from './propertyTokenMap';
import { Pressable } from 'react-native';
function getVariantProps(props, theme) {
  const variantTypes = theme !== null && theme !== void 0 && theme.variants ? Object.keys(theme.variants) : [];
  const restProps = {
    ...props
  };
  const variantProps = {};
  variantTypes === null || variantTypes === void 0 || variantTypes.forEach(variant => {
    if (props[variant]) {
      variantProps[variant] = props[variant];
      // delete restProps[variant];
    }
  });
  return {
    variantProps,
    restProps
  };
}
function resolveVariantAnimationProps(variantProps, styledObject) {
  let resolvedVariant = {};
  Object.keys(variantProps).forEach(variant => {
    var _styledObject$variant;
    const variantValue = variantProps[variant];
    const variantObject = styledObject === null || styledObject === void 0 || (_styledObject$variant = styledObject.variants) === null || _styledObject$variant === void 0 || (_styledObject$variant = _styledObject$variant[variant]) === null || _styledObject$variant === void 0 ? void 0 : _styledObject$variant[variantValue];
    resolvedVariant = deepMerge(resolvedVariant, variantObject);
  });
  return resolvedVariant;
}
const AnimatePresence = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const clonedChildren = [];
  React.Children.toArray(children).forEach(child => {
    var _child$type, _child$type2, _child$type3;
    if (child !== null && child !== void 0 && (_child$type = child.type) !== null && _child$type !== void 0 && _child$type.displayName && child !== null && child !== void 0 && (_child$type2 = child.type) !== null && _child$type2 !== void 0 && _child$type2.displayName.includes('Gluestack-AnimatedResolver') || child !== null && child !== void 0 && (_child$type3 = child.type) !== null && _child$type3 !== void 0 && _child$type3.isStyledComponent) {
      var _child$type4, _restProps$sx;
      const componentStyledObject = child === null || child === void 0 || (_child$type4 = child.type) === null || _child$type4 === void 0 || (_child$type4 = _child$type4.getStyledData()) === null || _child$type4 === void 0 ? void 0 : _child$type4.config;
      const {
        variantProps,
        restProps
      } = getVariantProps({
        ...(componentStyledObject === null || componentStyledObject === void 0 ? void 0 : componentStyledObject.props),
        ...(child === null || child === void 0 ? void 0 : child.props)
      }, componentStyledObject);
      const variantStyledObject = resolveVariantAnimationProps(variantProps, componentStyledObject);
      const exit = {
        ...(componentStyledObject === null || componentStyledObject === void 0 ? void 0 : componentStyledObject[':exit']),
        ...(variantStyledObject === null || variantStyledObject === void 0 ? void 0 : variantStyledObject[':exit']),
        ...(restProps === null || restProps === void 0 || (_restProps$sx = restProps.sx) === null || _restProps$sx === void 0 ? void 0 : _restProps$sx[':exit']),
        ...(restProps === null || restProps === void 0 ? void 0 : restProps.exit)
      };
      if (Object.keys(exit ?? {}).length > 0) {
        const clonedChild = /*#__PURE__*/React.cloneElement(child, {
          exit,
          ...restProps
        });
        clonedChildren.push(clonedChild);
      } else {
        clonedChildren.push(child);
      }
    } else {
      clonedChildren.push(child);
    }
  });
  return /*#__PURE__*/React.createElement(MotionAnimatePresence, _extends({
    ref: ref
  }, props), clonedChildren);
});
const AnimatedPressable = createMotionAnimatedComponent(
// @ts-ignore
Pressable);
const MotionComponents = {
  ...Motion,
  ...MotionSvg,
  Pressable: AnimatedPressable,
  AnimatePresence
};
export class MotionAnimationDriver {
  engine = MotionComponents;
  config = {
    aliases: {
      ':animate': 'animate',
      ':initial': 'initial',
      ':exit': 'exit',
      ':initialProps': 'initialProps',
      ':animateProps': 'animateProps',
      ':transition': 'transition',
      ':transformOrigin': 'transformOrigin',
      ':whileTap': 'whileTap',
      ':whileHover': 'whileHover',
      ':onAnimationComplete': 'onAnimationComplete'
    }
  };
  register(config) {
    if (this.config) {
      var _this$config, _this$config2;
      this.config.aliases = {
        ...((_this$config = this.config) === null || _this$config === void 0 ? void 0 : _this$config.aliases),
        ...(config === null || config === void 0 ? void 0 : config.aliases)
      };

      // @ts-ignore
      this.config.tokens = {
        // @ts-ignore
        ...((_this$config2 = this.config) === null || _this$config2 === void 0 ? void 0 : _this$config2.tokens),
        ...(config === null || config === void 0 ? void 0 : config.tokens)
      };

      // @ts-ignore
      this.config.ref = config === null || config === void 0 ? void 0 : config.ref;
    }
  }
  constructor(config) {
    this.register(config);
    this.name = 'MotionAnimationDriver';
    this.engine.AnimatePresence.defaultProps = {
      ...this.engine.AnimatePresence.defaultProps,
      config
    };
  }
}
//# sourceMappingURL=index.js.map